import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { Quill } from 'react-quill';
import 'quill-mention';

import api from '../../Environment';

import 'react-quill/dist/quill.snow.css';
import './styles/QuillEditor.scss';

const QuillEditor = ({ placeholder = '', value, className = '', onChange, ...props }) => {
  const [quill, setQuill] = useState(null);

  async function fetchUsers(q) {
    const response = await api.postMethod('search_users', {
      username: q,
    });

    const users = (response?.data?.data || []).map((user) => ({
      ...user,
      value: user.username,
      link: `/user/${encodeURIComponent(user?.username?.toUpperCase())}`,
    }));
    return users;
  }

  const handleBounceEverything = debounce(async (searchTerm, renderList) => {
    const values = await fetchUsers(searchTerm);

    renderList(values, searchTerm);
  }, 500);

  useEffect(() => {
    if (quill && quill.root.innerHTML !== value && value == '') {
      quill.root.innerHTML = value;
    }
  }, [value]);

  useEffect(() => {
    const q = new Quill(`#${props.id || 'comment-input-editor'}`, {
      readOnly: props.readOnly,
      placeholder: placeholder,
      modules: {
        keyboard: {
          bindings: {
            enter: {
              key: 13,
              handler: () => {
                props.handleSubmit(q.root.innerHTML);
              },
            },
          },
        },
        mention: {
          allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
          mentionDenotationChars: ['@'],
          source: handleBounceEverything,
          renderItem: function (item) {
            return `${item.username}`;
          },
          renderLoading: function () {
            return 'Loading ...';
          },
          onSelect: function (item, insertItem) {
            insertItem(item);
          },
          // positioningStrategy: function (range, mentionChar, mentionText) {
          //   const editor = quill;
          //   const mentionCharIndex = range.index - 1; // Adjust for the "@" character
          //   const offset = editor.getBounds(range.index);
          //   const leftPos = offset.left;
          //   const topPos = offset.bottom;

          //   return {
          //     left: `${leftPos} !important`,
          //     top: `${topPos} !important`,
          //     display: 'block',
          //     position: 'absolute',
          //     transform: 'translate(-50%, 0)', // Adjust this based on your layout
          //   };
          // },
        },

      },
    });

    setQuill(q);
    if (value) {
      q.root.innerHTML = value;
    }

    if (props.focus) {
      setTimeout(() => {
        q.setSelection(q.getLength(), 0);
        q.focus();
      }, 0);
    }

    q.on('text-change', function (delta) {
      onChange(q.root.innerHTML, delta);
    });
  }, []);

  return <div id={props.id || `comment-input-editor`} className={className} translate="no"x></div>;
};

export default QuillEditor;
